import { useEffect } from 'react';

type Options = {
    message: string;
    enabled?: boolean;
};

const useBeforeUnload = ({ message, enabled = true }: Options) => {
    useEffect(() => {
        window.onbeforeunload = enabled
            ? () => {
                  return message;
              }
            : null;

        return () => {
            window.onbeforeunload = null;
        };
    }, [message, enabled]);
};

export default useBeforeUnload;
